import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';

import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { useDropdownContext } from 'widgets/Dropdown';

interface FilterActionsProps {
    onApply: () => void;
    onReset: () => void;
}

export const FilterActions = ({ onReset, onApply }: FilterActionsProps) => {
    const dropdownContext = useDropdownContext();

    return (
        <div className="flex gap-2">
            <Button
                className="flex-1"
                variant="outline"
                onClick={() => {
                    dropdownContext?.closeDropdown();
                    onReset();
                }}
            >
                Clear
            </Button>
            <Button
                className="flex-1"
                type="submit"
                onClick={() => {
                    dropdownContext?.closeDropdown();
                    onApply();
                }}
            >
                Apply
            </Button>
        </div>
    );
};

interface FilterButtonProps {
    filterCount?: number;
    onClick?: () => void;
}

export const FilterButton = ({ filterCount = 0, onClick, children }: PropsWithChildren<FilterButtonProps>) => {
    return (
        <Button className="relative" variant="outline" onClick={onClick}>
            {children}
            {filterCount > 0 && (
                <Badge
                    variant="default"
                    className="absolute -top-1.5 -right-1 flex h-5 min-w-5 items-center justify-center rounded-full px-1 text-center font-mono tabular-nums"
                >
                    {filterCount}
                </Badge>
            )}
        </Button>
    );
};

export const StyledFilterButton = styled(Button)<{ $active: boolean }>`
    ${({ theme, $active }) => ($active ? `border-color: ${theme.colors.cocoa900}` : '')};
    min-width: unset;
    font-size: 0.875rem;
    color: ${({ theme }) => theme.colors.cocoa500};
    height: 36px;
    font-weight: 300;
`;

export const ResetFiltersButton = styled(Button)`
    min-width: unset;
`;
